/* eslint-disable no-console */
import crypto from 'crypto';

function safeStringify(obj) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) return '[Circular]';
      seen.add(value);
    }
    return value;
  });
}

export function extractFetchContext(err) {
  if (!err || typeof err !== 'object') return {};
  const ctx = {};
  // axios error shape
  if (err.config && err.config.url) ctx.url = err.config.url;
  if (err.config && err.config.method) ctx.method = err.config.method;
  if (err.response && err.response.status) ctx.status = err.response.status;
  // node-fetch error shape
  if (!ctx.url && err.url) ctx.url = err.url;
  if (err.code) ctx.code = err.code;
  return ctx;
}

export function logError(err, context = {}) {
  const errorId = (context && context.errorId) || crypto.randomUUID();
  const payload = {
    level: 'error',
    timestamp: new Date().toISOString(),
    errorId,
    message: err && err.message ? err.message : String(err),
    name: err && err.name ? err.name : undefined,
    stack: err && err.stack ? err.stack : undefined,
    ...extractFetchContext(err),
    ...context,
  };
  console.error(safeStringify(payload));
  return errorId;
}

export function logEvent(level, msg, fields = {}) {
  const payload = {
    level,
    timestamp: new Date().toISOString(),
    message: msg,
    ...fields,
  };
  const line = safeStringify(payload);
  if (level === 'error' || level === 'warn') {
    console.error(line);
  } else {
    console.log(line);
  }
}
